import React from 'react';
import { Icon } from 'antd';

/**
 * TableLegend Component
 * Displays a rubric for icon meanings above tables.
 * 
 * @param {Object} props
 * @param {Array} props.items - Array of { type, className, label } objects
 */
const TableLegend = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="table-legend">
      {items.map((item, index) => (
        <div className="legend-item" key={index}>
          <Icon type={item.type} className={item.className} />
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default TableLegend;
